import { render, staticRenderFns } from "./form-documents.vue?vue&type=template&id=7c2e928c&scoped=true"
import script from "./form-documents.vue?vue&type=script&lang=js"
export * from "./form-documents.vue?vue&type=script&lang=js"
import style0 from "./form-documents.vue?vue&type=style&index=0&id=7c2e928c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e928c",
  null
  
)

export default component.exports